import {
  useCurrentToolId,
  useCurrentProductId,
  PRODUCT_IDS,
  ProductIdType,
} from '@adsk/alloy-provider';

import { MeetingItem } from '../types';

export function useEntityLink(projectId: string, entity: MeetingItem) {
  const toolId = useCurrentToolId() as string;

  let productId = useCurrentProductId() || PRODUCT_IDS.BUILD;

  if (
    !(
      [
        PRODUCT_IDS.BUILD,
        PRODUCT_IDS.MODEL_COORDINATION,
        PRODUCT_IDS.DESIGN_COLLABORATION,
      ] as ProductIdType[]
    ).includes(productId)
  ) {
    productId = PRODUCT_IDS.BUILD;
  }

  const mappedProductPaths = {
    [PRODUCT_IDS.MODEL_COORDINATION]: 'model',
    [PRODUCT_IDS.DESIGN_COLLABORATION]: 'dc',
  };

  //@ts-expect-error should be inferred
  productId = mappedProductPaths[productId] || productId;

  return `/${productId}/meetings/projects/${projectId}/meeting/${entity.meeting.id}?item=${entity.id}&origin=${toolId}`;
}
